@import '../../../../../../../constants/spacing.module.less';

.edit-content {
  min-height: 224px;
  display: flex;
  flex-direction: column;
  padding: @space-16;
  gap: @space-16;
}

.add-button {
  display: flex;
  align-items: center;
  gap: @space-8;

  > svg {
    width: 12px;
  }
}

.instructions {
  color: var(--default--text-color--16);
}

.tax-identifier-field {
  width: 100%;
}

.dropdown-toggler {
  height: 32px;
}

.placeholder {
  color: var(--default--text-color--15);
}

.footer {
  height: fit-content;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  padding: @space-16 @space-0;
}

.footer-right-side {
  display: flex;
  align-items: flex-end;
  gap: @space-8;
}

.remove-icon {
  display: flex;
  width: 14px;
  height: 16px;
  align-items: center;
  fill: var(--grey-600);
}

.tax-id-table {
  border-collapse: collapse;
  overflow: hidden;
  width: 100%;

  tr {
    border: 1px solid var(--default--border-color--6);
  }

  th {
    padding: @space-8;
    text-align: left;
    background: var(--default--background-color--4);
  }

  th:last-child {
    width: 0;
  }

  td {
    font-size: 14px;
    line-height: 24px;
    padding: @space-8;
    vertical-align: top;
  }

  td:last-child {
    padding-right: @space-16;
  }
}

.tax-id-button {
  margin-top: @space-8;
}
